import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase, RequestStatus } from '@lib/plugin-redux-core';
import { STOP_MESSAGE_USE_CASE } from '../../../ai';
import { selectCurrentMessageId, selectSendMessageOutput, selectStopMessageStatus } from '../redux/ai-chat/ai-chat.selectors';
export var useStopMessage = function useStopMessage(_ref) {
  var conversationId = _ref.conversationId,
      onProcessingChange = _ref.onProcessingChange,
      onStopRequested = _ref.onStopRequested;
  var dispatch = useDispatch();

  var _useState = useState(false),
      isStoppedByUser = _useState[0],
      setIsStoppedByUser = _useState[1];

  var currentMessageId = useSelector(selectCurrentMessageId);
  var sendMessageOutput = useSelector(selectSendMessageOutput);
  var stopMessageStatus = useSelector(selectStopMessageStatus);
  var stopMessageUseCase = getUseCase(STOP_MESSAGE_USE_CASE, dispatch);
  useEffect(function () {
    if (stopMessageStatus === RequestStatus.SUCCESS) {
      stopMessageUseCase.reset();
    }
  }, [stopMessageStatus, stopMessageUseCase]);
  useEffect(function () {
    if (!isStoppedByUser) return;
    var t = setTimeout(function () {
      return setIsStoppedByUser(false);
    }, 2000);
    return function () {
      return clearTimeout(t);
    };
  }, [isStoppedByUser]);
  var handleUserStopRequest = useCallback(function () {
    onStopRequested === null || onStopRequested === void 0 ? void 0 : onStopRequested();
    setIsStoppedByUser(true);
    onProcessingChange === null || onProcessingChange === void 0 ? void 0 : onProcessingChange(false);
    var messageId = currentMessageId;

    if (conversationId && messageId) {
      stopMessageUseCase.execute({
        conversationId: conversationId,
        messageId: messageId,
        unsubscribe: sendMessageOutput === null || sendMessageOutput === void 0 ? void 0 : sendMessageOutput.unsubscribe
      });
    }
  }, [conversationId, currentMessageId, sendMessageOutput, stopMessageUseCase, onStopRequested, onProcessingChange]);
  return {
    isStoppedByUser: isStoppedByUser,
    handleUserStopRequest: handleUserStopRequest
  };
};